<script setup lang="ts" generic="ListingFilter extends { code: string }">
import SwFilterPropertiesVue from "~/components/cms/listing-filters/SwFilterProperties.vue";
import SwFilterPriceVue from "~/components/cms/listing-filters/SwFilterPrice.vue";
import SwFilterRatingVue from "~/components/cms/listing-filters/SwFilterRating.vue";
import SwFilterShippingFreeVue from "~/components/cms/listing-filters/SwFilterShippingFree.vue";

const emit = defineEmits<{
  (e: "selectFilterValue", { code, value }: { code: any; value: any }): void;
}>();

const props = defineProps<{
  filter: ListingFilter;
  selectedFilters: {
    [key: string]: any;
  };
}>();

const cmsMap = () => {
  const map: {
    [key: string]: any;
  } = {
    manufacturer: SwFilterPropertiesVue,
    properties: SwFilterPropertiesVue,
    price: SwFilterPriceVue,
    rating: SwFilterRatingVue,
    "shipping-free": SwFilterShippingFreeVue,
  };

  return map[props.filter?.code];
};
</script>
<template>
  <div class="select select--alt">
    <component
      :is="cmsMap()"
      :filter="filter"
      :selectedFilters="selectedFilters"
      @select-value="emit('selectFilterValue', $event)"
    />
  </div>
</template>
